export default {
  view: 'supplier.view_category',
  add: 'supplier.add_category',
  change: 'supplier.change_category',
  delete: 'supplier.delete_category',
};
